/* Geladi Mega Menu behavior - hover-open on desktop, click-to-toggle,
   close on outside click / Escape, and a body class for the backdrop.
   Mobile (<=989px) falls back to the drawer; this script no-ops there. */
(() => {
  'use strict';

  const DESKTOP_MQ = window.matchMedia('(min-width: 990px)');
  const HOVER_OPEN_DELAY = 90;   // ms - slight delay so we don't open by accident
  const HOVER_CLOSE_DELAY = 220; // ms - lets the cursor traverse to the panel

  const triggers = () => Array.from(document.querySelectorAll('.geladi-mega-menu-trigger'));

  function closeAll(except) {
    triggers().forEach((t) => {
      if (t === except) return;
      const details = t.querySelector('.geladi-mega-details');
      if (details && details.open) details.open = false;
    });
    refreshBodyClass();
  }

  function refreshBodyClass() {
    const anyOpen = triggers().some((t) => {
      const d = t.querySelector('.geladi-mega-details');
      return d && d.open;
    });
    document.body.classList.toggle('geladi-mega-open', anyOpen && DESKTOP_MQ.matches);
    // (Backdrop removed - class is harmless but kept for future hooks.)
  }

  function wireTrigger(trigger) {
    const details = trigger.querySelector('.geladi-mega-details');
    if (!details) return;
    const summary = details.querySelector('summary');
    if (!summary) return;

    let openTimer = null;
    let closeTimer = null;

    const cancelTimers = () => {
      if (openTimer)  { clearTimeout(openTimer);  openTimer  = null; }
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
    };

    const open = () => {
      cancelTimers();
      if (!details.open) {
        // Close other open mega menus first
        closeAll(trigger);
        details.open = true;
        refreshBodyClass();
      }
    };
    const close = () => {
      cancelTimers();
      if (details.open) {
        details.open = false;
        refreshBodyClass();
      }
    };

    // Hover (desktop only)
    trigger.addEventListener('mouseenter', () => {
      if (!DESKTOP_MQ.matches) return;
      cancelTimers();
      openTimer = setTimeout(open, HOVER_OPEN_DELAY);
    });
    trigger.addEventListener('mouseleave', () => {
      if (!DESKTOP_MQ.matches) return;
      cancelTimers();
      closeTimer = setTimeout(close, HOVER_CLOSE_DELAY);
    });

    // Native <details> handles click toggling. We just sync the body class.
    details.addEventListener('toggle', refreshBodyClass);

    // Clicking a child link should close the menu (and let the link navigate)
    details.querySelectorAll('a').forEach((a) => {
      a.addEventListener('click', () => {
        // Defer so navigation can proceed first; cosmetic close for SPA-ish feel
        setTimeout(close, 60);
      });
    });
  }

  function init() {
    triggers().forEach(wireTrigger);

    // Close on outside click
    document.addEventListener('click', (e) => {
      if (!DESKTOP_MQ.matches) return;
      const inside = e.target.closest('.geladi-mega-menu-trigger');
      if (!inside) closeAll();
    });

    // Close on Escape
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeAll();
    });

    // Close all on viewport switch to/from mobile
    DESKTOP_MQ.addEventListener('change', () => closeAll());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
